module.exports = __webpack_public_path__ + "img/10d.a97b4ab0.svg";